var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"allWorks"}},[_c('div',{staticClass:"works"},_vm._l((_vm.works),function(work,index){return _c('Work',{key:index,attrs:{"work":work,"nome":index,"iSrc":require('../assets/works'+work.mainFoto)}})}),1),_c('div',{staticClass:"contatti"},[_c('Contatti')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }